import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BranchSettingsService } from "../../../branch-settings/branch-settings.service";
import { Branch } from "../../../branch-settings/branch-settings.interface";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { EmployeesService } from "../../../employees/employees.service";
import { EmployeeListItem } from "../../../employees/employees.interface";

@Component({
  selector: "app-install-branch",
  templateUrl: "./install-branch.component.html",
  styleUrls: ["./install-branch.component.scss"],
  standalone: false,
})
export class InstallBranchComponent implements OnInit {
  displayedColumns = ["expand", "name", "employeesCount", "assign"];
  dataSource: MatTableDataSource<Branch>;
  expandedBranchId: string | null = null;
  membersMap = new Map<string, EmployeeListItem[]>();
  loadingBranchId: string | null = null;
  @Input() updating?: boolean;
  @Output() clicked = new EventEmitter<string>();
  @ViewChild(MatSort) sort: MatSort;
  isLoading = false;
  isDataLoaded = false;

  constructor(
    private branchSettingsService: BranchSettingsService,
    private employeesService: EmployeesService,
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Branch>([]);
  }

  loadData(): void {
    if (this.isDataLoaded) {
      return;
    }
    this.isLoading = true;
    this.branchSettingsService.fetchBranches().subscribe({
      next: (data) => {
        this.dataSource.data = data;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        this.isDataLoaded = true;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  toggleMembers(branchId: string): void {
    const branch = this.dataSource.data.find((b) => b.branchId === branchId);
    if (!branch || (branch.employeeIds?.length ?? 0) === 0) {
      return;
    }
    if (this.expandedBranchId === branchId) {
      this.expandedBranchId = null;
      return;
    }
    this.expandedBranchId = branchId;
    if (this.membersMap.has(branchId)) {
      return;
    }
    this.loadingBranchId = branchId;
    this.employeesService
      .getEmployees(
        {
          branchId,
          pager: { limit: 500, page: 0 },
        },
        false,
      )
      .subscribe({
        next: (res) => {
          this.membersMap.set(branchId, res.data);
          this.loadingBranchId = null;
        },
        error: () => {
          this.loadingBranchId = null;
        },
      });
  }

  getMembers(branchId: string): EmployeeListItem[] {
    return this.membersMap.get(branchId) ?? [];
  }

  assign(branchId: string): void {
    this.clicked.emit(branchId);
  }
}
